import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { CreatableProps as CreatableSelectProps } from 'react-select/creatable'

import {
  RSCreatableSelectWithEditableValue,
  RSCreatableSelectWithEditableValueProps
} from './components/RSCreatableSelectWithEditableValue'
import { Option } from '../../../lib/options'
import { selectCss } from './styles'
import { CustomOption } from './components/CustomOption'
import cx from 'classnames'

type Props = RSCreatableSelectWithEditableValueProps & {
  $minWidth?: number
  'data-test'?: string
  formatInvalidCreateLabel?: (inputValue: string) => ReactNode
  stopClickPropagation?: boolean
  value?: CreatableSelectProps<Option, false, any>['value']
}

export const FeedbotCreatableSelect: FC<Props> = ({
  stopClickPropagation = true,
  'data-test': dataTest,
  className,
  ...rest
}) => {
  return (
    <Wrapper
      data-test={cx('creatable-select', dataTest)}
      className={className}
      onClick={e => stopClickPropagation && e.stopPropagation()}
    >
      <StyledRSCreatableSelectWithEditableValue
        {...rest}
        components={{ Option: CustomOption as any, ...rest.components }}
      />
    </Wrapper>
  )
}

const CLASSNAME_PREFIX = 'styled-creatable-select'

const StyledRSCreatableSelectWithEditableValue = styled(RSCreatableSelectWithEditableValue).attrs({
  classNamePrefix: CLASSNAME_PREFIX as string | null | undefined
})<{ $minWidth?: number }>`
  ${selectCss};

  .${CLASSNAME_PREFIX}__placeholder.${CLASSNAME_PREFIX}__placeholder {
    position: static;
    transform: unset;
    order: 99;
    margin-left: 3px;
  }

  .${CLASSNAME_PREFIX}__input.${CLASSNAME_PREFIX}__input {
    max-width: 40em;

    input {
      min-width: fit-content !important;
    }
  }

  .${CLASSNAME_PREFIX}__value-container.${CLASSNAME_PREFIX}__value-container {
    flex-wrap: nowrap;
  }

  min-width: ${props => props.$minWidth + 'px'};
  z-index: 21;
`

const Wrapper = styled.div`
  width: 100%;
`

export type FeedbotCreatableSelectProps = Props
